import React from 'react';
import './SearchResultsBanner.scss';
import SearchInput from '../Search';
import TopArticle from '../../topArticle/TopArticle'
import SearchResults from '../searchResults/SearchResults';

const SearchResultsBanner: React.FC = () => {
    return (
        <>
            <div className="search-banner-container">
                <div className="banner-img"></div>

                <TopArticle />
                <div className="container data-container">
                    <SearchInput showFieldSelector={true} />
                    <SearchResults />
                </div>
            </div>
        </>
    );
};

export default SearchResultsBanner;
